<div class="standalone-form">
  <!-- The Order Protection editor owns the tabbed Settings/Appearance UI, including the
       "Add widget to cart" embed card. This wrapper only handles load/save + the Back/Save header. -->
  @if (loading) {
    <div class="standalone-form__loading">
      <pdq-spinner></pdq-spinner>
    </div>
  } @else if (ready) {
    <smart-cart-form-order-protection-editor
      [formGroup]="orderProtectionForm"
      [usageToken]="usageToken"></smart-cart-form-order-protection-editor>
  }
</div>
